module.exports = [{"name":"Business Associate Agreement (BAA - Editable)","papers":[{"title":"Business Associate Agreement","id":"auth0-baa-editable","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-word-92c794e490.svg","date":"October, 2017","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/baa-edit-oct-17.docx"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/baa-editable/data/baaPapers.json
// module id = 1639
// module chunks = 0